/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsShield: {
  name: 'shield';
  data: string;
} = {
  name: 'shield',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.106 2.33a2 2 0 0 1 1.789 0l7 3.5a1.964 1.964 0 0 1 1.091 1.831c-.318 7.734-6.116 12.507-7.884 13.793-.66.48-1.544.48-2.204 0-1.768-1.286-7.566-6.06-7.884-13.793A1.964 1.964 0 0 1 4.106 5.83l7-3.5Zm7.88 5.281L12 4.118 5.013 7.611c.29 6.646 5.249 10.89 6.987 12.171 1.738-1.282 6.698-5.525 6.987-12.17Zm.014.007Zm-14 0Z" fill="currentColor"/></svg>`,
};
